<template>
    <div class="page-abate">
        <div class="page-header">
            <div>
                <h1>Gerenciamento de Acompanhamentos de Abate</h1>
                <p>
                    Controle integrado do acompanhamento de abate, registros ante mortem
                    e lançamentos de doenças, condenações e destino sanitário.
                </p>
            </div>

            <div class="header-badges">
                <span class="badge badge-blue">POC</span>
                <span class="badge badge-green">Fluxo Integrado</span>
            </div>
        </div>

        <div class="summary-cards">
            <div class="summary-card">
                <span class="summary-label">Acompanhamentos</span>
                <strong>{{ acompanhamentos.length }}</strong>
            </div>
            <div class="summary-card">
                <span class="summary-label">Ante mortem</span>
                <strong>{{ registrosAnteMortem.length }}</strong>
            </div>
            <div class="summary-card">
                <span class="summary-label">Condenações</span>
                <strong>{{ registrosCondenacoes.length }}</strong>
            </div>
            <div class="summary-card">
                <span class="summary-label">Qtde abatida</span>
                <strong>{{ totalAbatida }}</strong>
            </div>
        </div>

        <div class="tabs-container">
            <button
                class="tab-button"
                :class="{ active: abaAtiva === 'acompanhamento' }"
                @click="abaAtiva = 'acompanhamento'"
            >
                Acompanhamento de Abate
            </button>

            <button
                class="tab-button"
                :class="{ active: abaAtiva === 'anteMortem' }"
                @click="abaAtiva = 'anteMortem'"
            >
                Registros Ante Mortem
            </button>

            <button
                class="tab-button"
                :class="{ active: abaAtiva === 'condenacoes' }"
                @click="abaAtiva = 'condenacoes'"
            >
                Doenças / Condenações / Destino
            </button>
        </div>

        <!-- ABA 1 -->
        <div v-if="abaAtiva === 'acompanhamento'" class="tab-content">
            <div class="content-grid">
                <div class="form-card">
                    <div class="card-title">Dados do Acompanhamento</div>

                    <div class="form-grid">
                        <div class="field span-2">
                            <label>Estabelecimento</label>
                            <select v-model="formAcompanhamento.estabelecimento">
                                <option value="">Selecione</option>
                                <option>Frigorífico Modelo LTDA</option>
                                <option>Abatedouro Bom Corte</option>
                                <option>Unidade Regional de Abate</option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Data</label>
                            <input type="date" v-model="formAcompanhamento.data" />
                        </div>

                        <div class="field">
                            <label>Turno</label>
                            <select v-model="formAcompanhamento.turno">
                                <option value="">Selecione</option>
                                <option>Manhã</option>
                                <option>Tarde</option>
                                <option>Noite</option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Hora inicial</label>
                            <input type="time" v-model="formAcompanhamento.horaInicio" />
                        </div>

                        <div class="field">
                            <label>Hora final</label>
                            <input type="time" v-model="formAcompanhamento.horaFim" />
                        </div>

                        <div class="field">
                            <label>Espécie</label>
                            <select v-model="formAcompanhamento.especie">
                                <option value="">Selecione</option>
                                <option>Bovinos</option>
                                <option>Suínos</option>
                                <option>Aves</option>
                                <option>Ovinos</option>
                                <option>Caprinos</option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Tipo de abate</label>
                            <select v-model="formAcompanhamento.tipoAbate">
                                <option value="">Selecione</option>
                                <option>Rotina</option>
                                <option>Emergencial</option>
                                <option>Sanitário</option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Quantidade abatida</label>
                            <input type="number" v-model="formAcompanhamento.quantidadeAbatida" min="0" />
                        </div>

                        <div class="field">
                            <label>Quantidade condenada</label>
                            <input type="number" v-model="formAcompanhamento.quantidadeCondenada" min="0" />
                        </div>

                        <div class="field span-2">
                            <label>Fiscal responsável</label>
                            <input type="text" v-model="formAcompanhamento.fiscal" placeholder="Nome do fiscal responsável" />
                        </div>

                        <div class="field">
                            <label>Situação</label>
                            <select v-model="formAcompanhamento.situacao">
                                <option value="">Selecione</option>
                                <option>Aberto</option>
                                <option>Concluído</option>
                                <option>Sincronizado</option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Possui ocorrência?</label>
                            <select v-model="formAcompanhamento.possuiOcorrencia">
                                <option>Não</option>
                                <option>Sim</option>
                            </select>
                        </div>

                        <div class="field span-4">
                            <label>Observações gerais</label>
                            <textarea
                                rows="4"
                                v-model="formAcompanhamento.observacoes"
                                placeholder="Informe observações sobre o acompanhamento, condições do abate, intercorrências, orientação emitida, etc."
                            ></textarea>
                        </div>
                    </div>

                    <div class="form-actions">
                        <button class="btn btn-primary" @click="salvarAcompanhamento">Salvar lançamento</button>
                        <button class="btn btn-secondary" @click="limparAcompanhamento">Limpar</button>
                    </div>
                </div>

                <div class="side-card">
                    <div class="card-title">Resumo do Registro</div>

                    <div class="mini-info">
                        <span>Estabelecimento</span>
                        <strong>{{ formAcompanhamento.estabelecimento || '-' }}</strong>
                    </div>
                    <div class="mini-info">
                        <span>Espécie</span>
                        <strong>{{ formAcompanhamento.especie || '-' }}</strong>
                    </div>
                    <div class="mini-info">
                        <span>Quantidade abatida</span>
                        <strong>{{ formAcompanhamento.quantidadeAbatida || 0 }}</strong>
                    </div>
                    <div class="mini-info">
                        <span>Quantidade condenada</span>
                        <strong>{{ formAcompanhamento.quantidadeCondenada || 0 }}</strong>
                    </div>
                    <div class="mini-info">
                        <span>Situação</span>
                        <strong>{{ formAcompanhamento.situacao || '-' }}</strong>
                    </div>

                    <div class="note-box">
                        Para operação real, este módulo pode ser utilizado no aplicativo em modo offline,
                        com sincronização posterior e posterior conferência no portal web.
                    </div>
                </div>
            </div>

            <div class="table-card">
                <div class="card-title">Histórico de Acompanhamentos</div>

                <div class="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Estabelecimento</th>
                                <th>Espécie</th>
                                <th>Turno</th>
                                <th>Qtde abatida</th>
                                <th>Qtde condenada</th>
                                <th>Fiscal</th>
                                <th>Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in acompanhamentos" :key="item.id">
                                <td>{{ item.data }}</td>
                                <td>{{ item.estabelecimento }}</td>
                                <td>{{ item.especie }}</td>
                                <td>{{ item.turno }}</td>
                                <td>{{ item.quantidadeAbatida }}</td>
                                <td>{{ item.quantidadeCondenada }}</td>
                                <td>{{ item.fiscal }}</td>
                                <td>
                                    <span class="status-pill" :class="statusClass(item.situacao)">
                                        {{ item.situacao }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- ABA 2 -->
        <div v-if="abaAtiva === 'anteMortem'" class="tab-content">
            <div class="content-grid">
                <div class="form-card">
                    <div class="card-title">Registro Ante Mortem</div>

                    <div class="form-grid">
                        <div class="field span-2">
                            <label>Acompanhamento vinculado</label>
                            <select v-model="formAnteMortem.idAcompanhamento">
                                <option value="">Selecione</option>
                                <option
                                    v-for="item in acompanhamentos"
                                    :key="item.id"
                                    :value="item.id"
                                >
                                    {{ item.data }} - {{ item.estabelecimento }} - {{ item.especie }}
                                </option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Quantidade avaliada</label>
                            <input type="number" v-model="formAnteMortem.quantidadeAvaliada" min="0" />
                        </div>

                        <div class="field">
                            <label>Quantidade apta</label>
                            <input type="number" v-model="formAnteMortem.quantidadeApta" min="0" />
                        </div>

                        <div class="field">
                            <label>Quantidade inapta</label>
                            <input type="number" v-model="formAnteMortem.quantidadeInapta" min="0" />
                        </div>

                        <div class="field">
                            <label>Segregação realizada?</label>
                            <select v-model="formAnteMortem.segregacao">
                                <option>Não</option>
                                <option>Sim</option>
                            </select>
                        </div>

                        <div class="field span-2">
                            <label>Sinais clínicos / alterações observadas</label>
                            <input
                                type="text"
                                v-model="formAnteMortem.sinais"
                                placeholder="Ex.: apatia, claudicação, alterações respiratórias, lesões..."
                            />
                        </div>

                        <div class="field span-4">
                            <label>Observações técnicas</label>
                            <textarea
                                rows="4"
                                v-model="formAnteMortem.observacoes"
                                placeholder="Descreva os apontamentos do exame ante mortem."
                            ></textarea>
                        </div>
                    </div>

                    <div class="form-actions">
                        <button class="btn btn-primary" @click="salvarAnteMortem">Salvar registro</button>
                        <button class="btn btn-secondary" @click="limparAnteMortem">Limpar</button>
                    </div>
                </div>

                <div class="side-card">
                    <div class="card-title">Objetivo do Ante Mortem</div>

                    <div class="timeline-box">
                        <p>
                            O registro ante mortem representa a avaliação sanitária dos animais
                            antes do abate, permitindo identificar situações de risco, segregações,
                            inaptidões e observações relevantes para a inspeção.
                        </p>
                    </div>
                </div>
            </div>

            <div class="table-card">
                <div class="card-title">Histórico de Registros Ante Mortem</div>

                <div class="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>Acompanhamento</th>
                                <th>Qtde avaliada</th>
                                <th>Apta</th>
                                <th>Inapta</th>
                                <th>Segregação</th>
                                <th>Sinais observados</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in registrosAnteMortem" :key="item.id">
                                <td>{{ item.referencia }}</td>
                                <td>{{ item.quantidadeAvaliada }}</td>
                                <td>{{ item.quantidadeApta }}</td>
                                <td>{{ item.quantidadeInapta }}</td>
                                <td>{{ item.segregacao }}</td>
                                <td>{{ item.sinais }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- ABA 3 -->
        <div v-if="abaAtiva === 'condenacoes'" class="tab-content">
            <div class="content-grid">
                <div class="form-card">
                    <div class="card-title">Registro de Doenças / Causas / Condenações / Destino</div>

                    <div class="form-grid">
                        <div class="field span-2">
                            <label>Acompanhamento vinculado</label>
                            <select v-model="formCondenacao.idAcompanhamento">
                                <option value="">Selecione</option>
                                <option
                                    v-for="item in acompanhamentos"
                                    :key="item.id"
                                    :value="item.id"
                                >
                                    {{ item.data }} - {{ item.estabelecimento }} - {{ item.especie }}
                                </option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Doença / alteração</label>
                            <input type="text" v-model="formCondenacao.doenca" placeholder="Ex.: cisticercose, abscesso, contusão..." />
                        </div>

                        <div class="field">
                            <label>Causa</label>
                            <input type="text" v-model="formCondenacao.causa" placeholder="Informe a causa identificada" />
                        </div>

                        <div class="field">
                            <label>Tipo de condenação</label>
                            <select v-model="formCondenacao.tipoCondenacao">
                                <option value="">Selecione</option>
                                <option>Total</option>
                                <option>Parcial</option>
                                <option>Aproveitamento condicional</option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Destino sanitário</label>
                            <select v-model="formCondenacao.destino">
                                <option value="">Selecione</option>
                                <option>Graxaria</option>
                                <option>Incineração</option>
                                <option>Descarte controlado</option>
                                <option>Aproveitamento condicional</option>
                            </select>
                        </div>

                        <div class="field">
                            <label>Quantidade envolvida</label>
                            <input type="number" v-model="formCondenacao.quantidade" min="0" />
                        </div>

                        <div class="field span-4">
                            <label>Observações</label>
                            <textarea
                                rows="4"
                                v-model="formCondenacao.observacoes"
                                placeholder="Detalhe a ocorrência, parte afetada, providência adotada e demais observações."
                            ></textarea>
                        </div>
                    </div>

                    <div class="form-actions">
                        <button class="btn btn-primary" @click="salvarCondenacao">Salvar registro</button>
                        <button class="btn btn-secondary" @click="limparCondenacao">Limpar</button>
                    </div>
                </div>

                <div class="side-card">
                    <div class="card-title">Rastreabilidade Sanitária</div>

                    <div class="mini-info">
                        <span>Fluxo da inspeção</span>
                        <strong>Acompanhamento → Ante mortem → Condenação/Destino</strong>
                    </div>

                    <div class="note-box">
                        Esse bloco consolida os registros sanitários posteriores ao acompanhamento,
                        fortalecendo a rastreabilidade das ocorrências e decisões técnicas adotadas.
                    </div>
                </div>
            </div>

            <div class="table-card">
                <div class="card-title">Histórico de Doenças / Condenações / Destino</div>

                <div class="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>Acompanhamento</th>
                                <th>Doença / alteração</th>
                                <th>Causa</th>
                                <th>Condenação</th>
                                <th>Destino</th>
                                <th>Quantidade</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in registrosCondenacoes" :key="item.id">
                                <td>{{ item.referencia }}</td>
                                <td>{{ item.doenca }}</td>
                                <td>{{ item.causa }}</td>
                                <td>{{ item.tipoCondenacao }}</td>
                                <td>{{ item.destino }}</td>
                                <td>{{ item.quantidade }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue';

const abaAtiva = ref('acompanhamento');

const acompanhamentos = ref([
    {
        id: 1,
        data: '18/03/2026',
        estabelecimento: 'Frigorífico Modelo LTDA',
        especie: 'Bovinos',
        turno: 'Manhã',
        quantidadeAbatida: 42,
        quantidadeCondenada: 2,
        fiscal: 'Carlos Henrique',
        situacao: 'Concluído',
    },
    {
        id: 2,
        data: '18/03/2026',
        estabelecimento: 'Abatedouro Bom Corte',
        especie: 'Suínos',
        turno: 'Tarde',
        quantidadeAbatida: 85,
        quantidadeCondenada: 4,
        fiscal: 'Marina Lopes',
        situacao: 'Sincronizado',
    },
    {
        id: 3,
        data: '19/03/2026',
        estabelecimento: 'Unidade Regional de Abate',
        especie: 'Aves',
        turno: 'Manhã',
        quantidadeAbatida: 320,
        quantidadeCondenada: 8,
        fiscal: 'João Paulo',
        situacao: 'Aberto',
    },
]);

const registrosAnteMortem = ref([
    {
        id: 1,
        referencia: '18/03/2026 - Frigorífico Modelo LTDA - Bovinos',
        quantidadeAvaliada: 42,
        quantidadeApta: 40,
        quantidadeInapta: 2,
        segregacao: 'Sim',
        sinais: 'Animais com apatia e alteração locomotora em 2 casos',
    },
    {
        id: 2,
        referencia: '18/03/2026 - Abatedouro Bom Corte - Suínos',
        quantidadeAvaliada: 85,
        quantidadeApta: 83,
        quantidadeInapta: 2,
        segregacao: 'Não',
        sinais: 'Sem alterações relevantes',
    },
]);

const registrosCondenacoes = ref([
    {
        id: 1,
        referencia: '18/03/2026 - Frigorífico Modelo LTDA - Bovinos',
        doenca: 'Abscesso localizado',
        causa: 'Processo inflamatório',
        tipoCondenacao: 'Parcial',
        destino: 'Graxaria',
        quantidade: 2,
        observacoes: '',
    },
    {
        id: 2,
        referencia: '18/03/2026 - Abatedouro Bom Corte - Suínos',
        doenca: 'Contaminação de carcaça',
        causa: 'Falha operacional',
        tipoCondenacao: 'Parcial',
        destino: 'Descarte controlado',
        quantidade: 4,
        observacoes: '',
    },
]);

const formAcompanhamento = reactive({
    estabelecimento: '',
    data: '',
    turno: '',
    horaInicio: '',
    horaFim: '',
    especie: '',
    tipoAbate: '',
    quantidadeAbatida: 0,
    quantidadeCondenada: 0,
    fiscal: '',
    situacao: 'Aberto',
    possuiOcorrencia: 'Não',
    observacoes: '',
});

const formAnteMortem = reactive({
    idAcompanhamento: '',
    quantidadeAvaliada: 0,
    quantidadeApta: 0,
    quantidadeInapta: 0,
    segregacao: 'Não',
    sinais: '',
    observacoes: '',
});

const formCondenacao = reactive({
    idAcompanhamento: '',
    doenca: '',
    causa: '',
    tipoCondenacao: '',
    destino: '',
    quantidade: 0,
    observacoes: '',
});

const totalAbatida = computed(() => {
    return acompanhamentos.value.reduce((acc, item) => acc + Number(item.quantidadeAbatida || 0), 0);
});

function formatarDataISOParaBR(dataIso) {
    if (!dataIso) return '';
    const partes = dataIso.split('-');
    if (partes.length !== 3) return dataIso;
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
}

function getReferenciaAcompanhamento(id) {
    const item = acompanhamentos.value.find(x => x.id === id);
    if (!item) return '';
    return `${item.data} - ${item.estabelecimento} - ${item.especie}`;
}

function salvarAcompanhamento() {
    acompanhamentos.value.unshift({
        id: Date.now(),
        data: formatarDataISOParaBR(formAcompanhamento.data),
        estabelecimento: formAcompanhamento.estabelecimento,
        especie: formAcompanhamento.especie,
        turno: formAcompanhamento.turno,
        quantidadeAbatida: Number(formAcompanhamento.quantidadeAbatida || 0),
        quantidadeCondenada: Number(formAcompanhamento.quantidadeCondenada || 0),
        fiscal: formAcompanhamento.fiscal,
        situacao: formAcompanhamento.situacao,
    });

    limparAcompanhamento();
}

function limparAcompanhamento() {
    formAcompanhamento.estabelecimento = '';
    formAcompanhamento.data = '';
    formAcompanhamento.turno = '';
    formAcompanhamento.horaInicio = '';
    formAcompanhamento.horaFim = '';
    formAcompanhamento.especie = '';
    formAcompanhamento.tipoAbate = '';
    formAcompanhamento.quantidadeAbatida = 0;
    formAcompanhamento.quantidadeCondenada = 0;
    formAcompanhamento.fiscal = '';
    formAcompanhamento.situacao = 'Aberto';
    formAcompanhamento.possuiOcorrencia = 'Não';
    formAcompanhamento.observacoes = '';
}

function salvarAnteMortem() {
    registrosAnteMortem.value.unshift({
        id: Date.now(),
        referencia: getReferenciaAcompanhamento(formAnteMortem.idAcompanhamento),
        quantidadeAvaliada: Number(formAnteMortem.quantidadeAvaliada || 0),
        quantidadeApta: Number(formAnteMortem.quantidadeApta || 0),
        quantidadeInapta: Number(formAnteMortem.quantidadeInapta || 0),
        segregacao: formAnteMortem.segregacao,
        sinais: formAnteMortem.sinais,
        observacoes: formAnteMortem.observacoes,
    });

    limparAnteMortem();
}

function limparAnteMortem() {
    formAnteMortem.idAcompanhamento = '';
    formAnteMortem.quantidadeAvaliada = 0;
    formAnteMortem.quantidadeApta = 0;
    formAnteMortem.quantidadeInapta = 0;
    formAnteMortem.segregacao = 'Não';
    formAnteMortem.sinais = '';
    formAnteMortem.observacoes = '';
}

function salvarCondenacao() {
    registrosCondenacoes.value.unshift({
        id: Date.now(),
        referencia: getReferenciaAcompanhamento(formCondenacao.idAcompanhamento),
        doenca: formCondenacao.doenca,
        causa: formCondenacao.causa,
        tipoCondenacao: formCondenacao.tipoCondenacao,
        destino: formCondenacao.destino,
        quantidade: Number(formCondenacao.quantidade || 0),
        observacoes: formCondenacao.observacoes,
    });

    limparCondenacao();
}

function limparCondenacao() {
    formCondenacao.idAcompanhamento = '';
    formCondenacao.doenca = '';
    formCondenacao.causa = '';
    formCondenacao.tipoCondenacao = '';
    formCondenacao.destino = '';
    formCondenacao.quantidade = 0;
    formCondenacao.observacoes = '';
}

function statusClass(status) {
    if (status === 'Sincronizado') return 'status-green';
    if (status === 'Concluído') return 'status-blue';
    if (status === 'Aberto') return 'status-orange';
    return '';
}
</script>

<style scoped>
.page-abate {
    padding: 20px;
    background: #f5f7fb;
    min-height: 100%;
    color: #1f2937;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header h1 {
    margin: 0 0 6px 0;
    font-size: 26px;
    font-weight: 700;
    color: #1e3a5f;
}

.page-header p {
    margin: 0;
    color: #5b6472;
    max-width: 900px;
}

.header-badges {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.badge {
    padding: 8px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.badge-blue {
    background: #dbeafe;
    color: #1d4ed8;
}

.badge-green {
    background: #dcfce7;
    color: #15803d;
}

.summary-cards {
    display: grid;
    grid-template-columns: repeat(4, minmax(180px, 1fr));
    gap: 14px;
    margin-bottom: 20px;
}

.summary-card {
    background: #ffffff;
    border-radius: 14px;
    padding: 16px;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);
    border: 1px solid #e5e7eb;
}

.summary-label {
    display: block;
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 6px;
}

.summary-card strong {
    font-size: 24px;
    color: #0f172a;
}

.tabs-container {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 18px;
}

.tab-button {
    border: none;
    background: #e5e7eb;
    color: #374151;
    padding: 12px 18px;
    border-radius: 12px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s ease;
}

.tab-button:hover {
    background: #dbeafe;
    color: #1d4ed8;
}

.tab-button.active {
    background: #1d4ed8;
    color: #ffffff;
    box-shadow: 0 8px 18px rgba(29, 78, 216, 0.20);
}

.tab-content {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.content-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 18px;
}

.form-card,
.side-card,
.table-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
}

.card-title {
    font-size: 18px;
    font-weight: 700;
    color: #1e3a5f;
    margin-bottom: 16px;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(120px, 1fr));
    gap: 14px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.field label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
}

.field input,
.field select,
.field textarea {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 14px;
    background: #fff;
    box-sizing: border-box;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.field input:focus,
.field select:focus,
.field textarea:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.span-2 {
    grid-column: span 2;
}

.span-4 {
    grid-column: span 4;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 18px;
}

.btn {
    border: none;
    border-radius: 10px;
    padding: 11px 16px;
    font-weight: 700;
    cursor: pointer;
}

.btn-primary {
    background: #1d4ed8;
    color: #fff;
}

.btn-primary:hover {
    background: #1e40af;
}

.btn-secondary {
    background: #e5e7eb;
    color: #374151;
}

.btn-secondary:hover {
    background: #d1d5db;
}

.mini-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px 0;
    border-bottom: 1px solid #eef2f7;
}

.mini-info span {
    font-size: 12px;
    color: #6b7280;
}

.mini-info strong {
    font-size: 15px;
    color: #111827;
}

.note-box,
.timeline-box {
    margin-top: 16px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px;
    color: #475569;
    line-height: 1.5;
}

.table-responsive {
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
}

thead th {
    text-align: left;
    background: #f8fafc;
    color: #334155;
    font-size: 13px;
    padding: 12px;
    border-bottom: 1px solid #e5e7eb;
}

tbody td {
    padding: 12px;
    border-bottom: 1px solid #eef2f7;
    font-size: 14px;
    color: #334155;
}

tbody tr:hover {
    background: #f9fbff;
}

.status-pill {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.status-green {
    background: #dcfce7;
    color: #166534;
}

.status-blue {
    background: #dbeafe;
    color: #1d4ed8;
}

.status-orange {
    background: #ffedd5;
    color: #c2410c;
}

@media (max-width: 1100px) {
    .content-grid {
        grid-template-columns: 1fr;
    }

    .summary-cards {
        grid-template-columns: repeat(2, minmax(180px, 1fr));
    }

    .form-grid {
        grid-template-columns: repeat(2, minmax(120px, 1fr));
    }

    .span-4 {
        grid-column: span 2;
    }
}

@media (max-width: 700px) {
    .page-header {
        flex-direction: column;
    }

    .summary-cards {
        grid-template-columns: 1fr;
    }

    .form-grid {
        grid-template-columns: 1fr;
    }

    .span-2,
    .span-4 {
        grid-column: span 1;
    }

    .form-actions {
        flex-direction: column;
    }
}
</style>